var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-secondary text-sm leading-4 underline font-bold cursor-pointer",on:{"click":_vm.openDialog}},[_vm._v(" Открыть диалог ")])}
var staticRenderFns = []

export { render, staticRenderFns }